var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path0, _g2, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndpoint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1907 18.1955C10.3579 18.1955 8.05273 15.8907 8.05273 13.0575C8.05273 10.228 10.3575 7.92657 13.1907 7.92657C16.0202 7.92657 18.3249 10.228 18.3249 13.0575C18.3315 15.8904 16.0268 18.1955 13.1907 18.1955ZM13.1907 8.56782C10.7131 8.56782 8.70059 10.5836 8.70059 13.0547C8.70059 15.5288 10.7131 17.5448 13.1907 17.5448C15.6648 17.5448 17.6808 15.5289 17.6808 13.0547C17.6841 10.5838 15.6716 8.56782 13.1907 8.56782Z",
    fill: "#001EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6283 8.78342C14.5851 8.78342 14.5454 8.77353 14.5022 8.76017C14.3361 8.6904 14.2598 8.50108 14.3295 8.34177L16.3056 3.53287C16.3753 3.36679 16.5647 3.28714 16.7273 3.3569C16.8934 3.42667 16.9697 3.61599 16.8999 3.7753L14.9239 8.5842C14.8774 8.71036 14.7578 8.78342 14.6283 8.78342Z",
    fill: "#001EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90292 9.86624C9.81997 9.86624 9.73684 9.83639 9.67038 9.76992L7.97008 8.0663C7.84721 7.94014 7.84721 7.73415 7.97008 7.60799C8.09624 7.48512 8.30223 7.48512 8.42839 7.60799L10.1287 9.31508C10.2515 9.43794 10.2515 9.64723 10.1287 9.7701C10.069 9.83656 9.98586 9.86641 9.90292 9.86641V9.86624Z",
    fill: "#001EFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40274 20.1347C4.30313 20.1347 4.20682 20.0948 4.14365 20.0118C4.03067 19.869 4.0607 19.6665 4.20334 19.5601L9.18147 15.7409C9.32429 15.6312 9.5268 15.6579 9.63318 15.8006C9.74616 15.9434 9.71613 16.1459 9.57349 16.2523L4.59537 20.0715C4.53897 20.1114 4.46921 20.1347 4.40274 20.1347Z",
    fill: "#001EFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0957 20.7492C16.9794 20.7492 16.8699 20.6895 16.81 20.5798L15.1295 17.4747C15.0465 17.3187 15.1029 17.1261 15.2589 17.0364C15.4149 16.9534 15.611 17.0098 15.6973 17.1658L17.3743 20.2709C17.4573 20.4269 17.4042 20.6196 17.2449 20.706C17.1951 20.7358 17.1453 20.7492 17.0954 20.7492L17.0957 20.7492Z",
    fill: "#001EFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2612 14.2101H17.9295C17.7502 14.2101 17.6074 14.0673 17.6074 13.8881C17.6074 13.7088 17.7502 13.566 17.9295 13.566H19.2612C19.4405 13.566 19.5833 13.7088 19.5833 13.8881C19.5833 14.0673 19.4405 14.2101 19.2612 14.2101Z",
    fill: "#001EFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_902_62431",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 5,
    height: 5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2344 0.191711H19.2188V4.12481H15.2344V0.191711Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_902_62431)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2258 4.10063C16.1497 4.10063 15.2729 3.22393 15.2729 2.14454C15.2729 1.06843 16.1497 0.195007 17.2258 0.195007C18.2984 0.195007 19.1753 1.06843 19.1753 2.14454C19.1753 3.22393 18.2986 4.10063 17.2258 4.10063ZM17.2258 0.842632C16.5051 0.842632 15.9206 1.4304 15.9206 2.14782C15.9206 2.86852 16.5051 3.45957 17.2258 3.45957C17.9432 3.45957 18.5276 2.8718 18.5276 2.14782C18.5276 1.4304 17.9431 0.842632 17.2258 0.842632Z",
    fill: "#001EFF"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.0467 8.63718C5.97406 8.63718 5.09717 7.76047 5.09717 6.68436C5.09717 5.61172 5.97387 4.73483 7.0467 4.73483C8.12281 4.73483 8.99951 5.61154 8.99951 6.68436C8.99951 7.76047 8.12281 8.63718 7.0467 8.63718ZM7.0467 5.38579C6.32928 5.38579 5.74484 5.97027 5.74484 6.69097C5.74484 7.4084 6.32932 7.98955 7.0467 7.98955C7.7674 7.98955 8.35189 7.40507 8.35189 6.68436C8.35189 5.96694 7.7674 5.38579 7.0467 5.38579Z",
    fill: "#001EFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.11115 22.7484C2.03504 22.7484 1.16162 21.875 1.16162 20.7989C1.16162 19.7263 2.03504 18.8494 3.11115 18.8494C4.18379 18.8494 5.06068 19.7261 5.06068 20.7989C5.06068 21.875 4.18398 22.7484 3.11115 22.7484ZM3.11115 19.5005C2.39045 19.5005 1.80596 20.085 1.80596 20.8057C1.80596 21.5231 2.39045 22.1109 3.11115 22.1109C3.82857 22.1109 4.41634 21.5231 4.41634 20.8057C4.41634 20.085 3.82857 19.5005 3.11115 19.5005Z",
    fill: "#001EFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_902_62431",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 19,
    width: 5,
    height: 5
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8906 19.875H19.8281V23.8079H15.8906V19.875Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_902_62431)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8664 23.8045C16.7903 23.8045 15.9136 22.9311 15.9136 21.855C15.9136 20.7823 16.7903 19.9055 17.8664 19.9055C18.939 19.9055 19.8159 20.7822 19.8159 21.855C19.8159 22.9311 18.9392 23.8045 17.8664 23.8045ZM17.8664 20.5566C17.1457 20.5566 16.5612 21.1411 16.5612 21.8618C16.5612 22.5792 17.1457 23.1636 17.8664 23.1636C18.5838 23.1636 19.1682 22.5792 19.1682 21.8618C19.1682 21.1411 18.5838 20.5566 17.8664 20.5566Z",
    fill: "#001EFF"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8885 15.8372C19.8159 15.8372 18.939 14.9638 18.939 13.8876C18.939 12.815 19.8157 11.9381 20.8885 11.9381C21.9646 11.9381 22.8413 12.8148 22.8413 13.8876C22.8413 14.9638 21.9646 15.8372 20.8885 15.8372ZM20.8885 12.5893C20.1711 12.5893 19.5833 13.1737 19.5833 13.8911C19.5833 14.6118 20.1711 15.1963 20.8885 15.1963C21.6092 15.1963 22.1937 14.6118 22.1937 13.8911C22.1937 13.1737 21.6092 12.5893 20.8885 12.5893Z",
    fill: "#001EFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.628 13.38C16.4487 13.38 16.3059 13.2372 16.3059 13.0579C16.3059 11.3377 14.911 9.94275 13.1907 9.94275C13.0115 9.94275 12.8687 9.79993 12.8687 9.61737C12.8687 9.43811 13.0115 9.29529 13.1907 9.29529C15.2664 9.29529 16.9535 10.9824 16.9535 13.0581C16.9535 13.234 16.8107 13.3802 16.6282 13.3802L16.628 13.38Z",
    fill: "#001EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndpoint);
export default __webpack_public_path__ + "static/media/endpoint.95d16d1ed2285d7c40cd1b969aa75911.svg";
export { ForwardRef as ReactComponent };